import React from 'react'

function Box(props) {
    return (
        <div className="w-full rounded-xl bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 p-6 my-4 shadow-lg">
            {props.children}
        </div>
    )
}

Box.propTypes = {

}

export default Box

